import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import SharedHeader from '../components/SharedHeader';
import SharedFooter from '../components/SharedFooter';

const PrivacyPolicy = () => {
  const { language, changeLanguage } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 text-white">
      <SharedHeader />

      {/* Main Content */}
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto bg-white text-gray-900 rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold mb-8 text-center">
            {t('privacyPolicyTitle')}
          </h1>
          
          <p className="text-gray-600 mb-8 text-center">
            {t('privacyLastUpdated')}: {t('privacyLastUpdatedDate')}
          </p>

          {/* Section 1: Data Collected */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacySection1Title')}
            </h2>
            <p className="text-gray-700 mb-4">
              {t('privacySection1Text')}
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>{t('privacySection1Item1')}</li>
              <li>{t('privacySection1Item2')}</li>
              <li>{t('privacySection1Item3')}</li>
              <li>{t('privacySection1Item4')}</li>
            </ul>
          </section>

          {/* Section 2: Usage */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacySection2Title')}
            </h2>
            <p className="text-gray-700 mb-4">
              {t('privacySection2Text')}
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>{t('privacySection2Item1')}</li>
              <li>{t('privacySection2Item2')}</li>
              <li>{t('privacySection2Item3')}</li>
              <li>{t('privacySection2Item4')}</li>
            </ul>
          </section>

          {/* Section 3: Storage */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacySection3Title')}
            </h2>
            <p className="text-gray-700">
              {t('privacySection3Text')}
            </p>
          </section>

          {/* Section 4: Security */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacySection4Title')}
            </h2>
            <p className="text-gray-700">
              {t('privacySection4Text')}
            </p>
          </section>

          {/* Section 5: User Rights */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacySection5Title')}
            </h2>
            <p className="text-gray-700 mb-4">
              {t('privacySection5Text')}
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>{t('privacySection5Item1')}</li>
              <li>{t('privacySection5Item2')}</li>
              <li>{t('privacySection5Item3')}</li>
              <li>{t('privacySection5Item4')}</li>
            </ul>
          </section>

          {/* Contact */}
          <section className="mb-8 bg-purple-100 p-6 rounded-lg">
            <h2 className="text-2xl font-bold mb-4 text-purple-900">
              {t('privacyContactTitle')}
            </h2>
            <p className="text-gray-700">
              {t('privacyContactText')}: <a href="mailto:privacy@liberado.vet" className="text-purple-700 font-semibold hover:underline">privacy@liberado.vet</a>
            </p>
          </section>
        </div>
      </main>

      <SharedFooter />
    </div>
  );
};

export default PrivacyPolicy;
